import { baseConfigName } from '@adornis/config/baseConfigName.js';

/**
 * Bridges the host page's config globals onto the key the engine actually reads.
 *
 * A standalone embed takes its runtime config from the page that hosts it: chancenwerk.de publishes
 * one object under `window['adornisConfig_' + k]` for a hard-coded list of keys, and every `Config`
 * the bundle constructs throws on load if its own key is missing from that list. The list was
 * written against the old engine and ends in 'base'.
 *
 * `@adornis/config` ships `baseConfigName` as the literal, unsubstituted template string
 * "{{ baseConfigName }}" -- neither the CLI nor the engine build replaces it. Server and client
 * agree on that literal, so the entrypoints themselves never notice, but the base config's key is
 * no longer 'base' and the host page's list therefore no longer covers it.
 *
 * Aliasing here instead of asking chancenwerk.de to add "{{ baseConfigName }}" to its list keeps an
 * engine bug out of a page we do not control, and the `??=` degrades to a no-op the moment
 * `baseConfigName` resolves to a real name again.
 *
 * Ordering matters: this has to run before anything touches `baseConfig`, and
 * `@adornis/base/env-info.js` does that on the first line of both entrypoints. Keep the import of
 * this module first in every `*.standalone.ts`.
 */
const globals = globalThis as unknown as Record<string, unknown>;

globals[`adornisConfig_${baseConfigName}`] ??= globals.adornisConfig_base ?? globals.adornisConfig_;
